import React, { Fragment } from "react";
import { ErrorMessage, Field } from "formik";
import { SALUTATION, FIRST_NAME, LAST_NAME, EMAIL, STREET, POSTAL_CODE, CITY, COUNTRY, CORPORATE_CLIENT, ORGANIZATION, VAT_ID } from "./field-names";
import { allCountries } from "./all-countries";
import { OPTION_SALUTATION_MR, OPTION_SALUTATION_MRS } from "./select-options";
import { withNamespace } from "../../../../util/forms/with-namespace";
var CustomerDataForm = function CustomerDataForm(_ref) {
    var namespace = _ref.namespace, hideEmailField = _ref.hideEmailField, fieldValues = _ref.fieldValues;
    return /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement("label", {
        className: "block mb-4"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, "Anrede"), /*#__PURE__*/ React.createElement("div", {
        className: "select-field"
    }, /*#__PURE__*/ React.createElement(Field, {
        as: "select",
        name: withNamespace(SALUTATION, namespace)
    }, /*#__PURE__*/ React.createElement("option", {
        value: OPTION_SALUTATION_MR
    }, "Herr"), /*#__PURE__*/ React.createElement("option", {
        value: OPTION_SALUTATION_MRS
    }, "Frau")))), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap mb-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full md:w-1/2 md:pr-2"
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, "Vorname"), /*#__PURE__*/ React.createElement(Field, {
        type: "text",
        name: withNamespace(FIRST_NAME, namespace),
        className: "text-field"
    })), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(FIRST_NAME, namespace),
        component: "div",
        className: "error-message"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "w-full md:w-1/2 md:pl-2"
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, "Nachname"), /*#__PURE__*/ React.createElement(Field, {
        type: "text",
        name: withNamespace(LAST_NAME, namespace),
        className: "text-field"
    })), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(LAST_NAME, namespace),
        component: "div",
        className: "error-message"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "block mb-4 " + (hideEmailField ? "hidden" : "show")
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, "E-Mail Adresse"), /*#__PURE__*/ React.createElement(Field, {
        type: "email",
        name: withNamespace(EMAIL, namespace),
        className: "text-field"
    })), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(EMAIL, namespace),
        component: "div",
        className: "error-message"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "block mb-4"
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, "Stra\xDFe und Hausnummer"), /*#__PURE__*/ React.createElement(Field, {
        type: "text",
        name: withNamespace(STREET, namespace),
        className: "text-field"
    })), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(STREET, namespace),
        component: "div",
        className: "error-message"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap mb-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full md:w-1/2 md:pr-2"
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, "Postleitzahl"), /*#__PURE__*/ React.createElement(Field, {
        type: "text",
        name: withNamespace(POSTAL_CODE, namespace),
        className: "text-field"
    })), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(POSTAL_CODE, namespace),
        component: "div",
        className: "error-message"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "w-full md:w-1/2 md:pl-2"
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, "Wohnort"), /*#__PURE__*/ React.createElement(Field, {
        type: "text",
        name: withNamespace(CITY, namespace),
        className: "text-field"
    })), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(CITY, namespace),
        component: "div",
        className: "error-message"
    }))), /*#__PURE__*/ React.createElement("label", {
        className: "block mb-8"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, "Land"), /*#__PURE__*/ React.createElement("div", {
        className: "select-field"
    }, /*#__PURE__*/ React.createElement(Field, {
        as: "select",
        name: withNamespace(COUNTRY, namespace)
    }, allCountries.map(function (country, index) {
        return /*#__PURE__*/ React.createElement("option", {
            value: country.code,
            key: index
        }, country.name);
    })))), /*#__PURE__*/ React.createElement("div", {
        className: "checkbox-field text-left mb-4 hidden"
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement(Field, {
        type: "checkbox",
        name: withNamespace(CORPORATE_CLIENT, namespace)
    }), /*#__PURE__*/ React.createElement("span", null, "Als ", /*#__PURE__*/ React.createElement("span", {
        className: "font-medium"
    }, "Firmenkunde"), " abonnieren.")), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(CORPORATE_CLIENT, namespace),
        component: "div",
        className: "error-message"
    })), fieldValues[CORPORATE_CLIENT] && /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "block mb-4"
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, "Firma / Organisation"), /*#__PURE__*/ React.createElement(Field, {
        type: "text",
        name: withNamespace(ORGANIZATION, namespace),
        className: "text-field"
    })), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(ORGANIZATION, namespace),
        component: "div",
        className: "error-message"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "block mb-4"
    }, /*#__PURE__*/ React.createElement("label", null, /*#__PURE__*/ React.createElement("span", {
        className: "label"
    }, "USt-ID"), /*#__PURE__*/ React.createElement(Field, {
        type: "text",
        name: withNamespace(VAT_ID, namespace),
        className: "text-field"
    })), /*#__PURE__*/ React.createElement(ErrorMessage, {
        name: withNamespace(VAT_ID, namespace),
        component: "div",
        className: "error-message"
    }))));
};
export default CustomerDataForm;
